import { Col, Container, Row } from 'react-bootstrap'
import { getBusinessEventDetails, getBusinessEventLabel, IntegrationServiceId } from '../../../../../../../common/integrations'
import React from 'react'
import { ContactLinking } from '../../ContactLinking/ContactLinking'
import { OutboundFieldMapping } from '../OutboundFieldMapping'
import { BusinessEventType } from '../../../../../../../models/BusinessEvent'

interface CustomBusinessEventsAdminSettingsProps {
  serviceId: IntegrationServiceId
  businessEventType: BusinessEventType
}

export const CustomBusinessEventsAdminSettings: React.FC<CustomBusinessEventsAdminSettingsProps> = ({ serviceId, businessEventType }) => {
  return (
    <Container className='py-3'>
      <Row className='mt-7'>
        <Col>
          <OutboundFieldMapping
            serviceId={serviceId}
            mappingKey={`businessEvents.${businessEventType}`}
            isUpdatable={false}
            inputTokenOptions={getBusinessEventDetails(businessEventType)}
            getLabelForObject={() => `'${getBusinessEventLabel(businessEventType)}'`}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <ContactLinking serviceId={serviceId} zocksObjectName={'Client Signals'} mappingPath={`mappings.businessEvents.${businessEventType}`} />
        </Col>
      </Row>
    </Container>
  )
}
